import React from 'react'

import DatePicker from '../../datepicker/DatePicker'
import dateUtils from 'shared/src/date'

import { getProps } from './utils'

const Date = (props) => {

  const {
    field: {
      name,
      value,
    },
    form: {
      setFieldValue,
    },
    item,
  } = getProps(props)

  const onChange = (value) => {
    setFieldValue(name, dateUtils.dateToString(value))
  }

  return (
    <DatePicker
      label={ item.title || item.id }
      value={ dateUtils.stringToDate(value) }
      onChange={ onChange }
    />
  )
}

export default Date